import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReportUserService } from 'app/services/report-user.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-report-user-roles',
  templateUrl: './report-user-roles.component.html',
  styleUrls: ['./report-user-roles.component.css']
})
export class ReportUserRolesComponent implements OnInit {

  @Output() infoReport = new EventEmitter<string>();
  @Output() showInfo = new EventEmitter<boolean>();

  showUserUserRoles: boolean;
  showLogin: boolean;
  showEmail: boolean;
  showReport: boolean;
  showReportUserRoles: boolean;
  report;

  login: string;
  email: string;

  companies: SelectItem[] = [];
  companySelectedUserRoles;

  users: SelectItem[] = [];
  userSelectedUserRoles;

  constructor(private reportService: ReportUserService, private translate: TranslateService) { }

  ngOnInit() {
    // ottengo gli utenti e popolo la dropdown
    this.reportService.getUsers().subscribe(res => {
      this.users = res;
    });

    // ottengo le company e popolo la dropdown
    this.reportService.getCompanies().subscribe(res => {
      this.companies = res;
    });
  }

  reportUserRoles() {
    if (this.companySelectedUserRoles == null) {
      this.companySelectedUserRoles = this.companies[0].value;
    }

    if (this.showUserUserRoles && this.userSelectedUserRoles == null) {
      this.userSelectedUserRoles = this.users[0].value;
    } else if (!this.showUserUserRoles) {
      this.userSelectedUserRoles = null;
    }

    if (!this.showLogin) {
      this.login = null;
    }

    if (!this.showEmail) {
      this.email = null;
    }

    this.showReport = false;
    this.reportService.getReportUserRoles(this.companySelectedUserRoles, this.userSelectedUserRoles, this.login, this.email).subscribe(res=> {
      this.showReport = true;
      this.report = res;
      this.showReportUserRoles = true;
    });
  }

  openDialog(reportType) {
    this.infoReport.emit(this.translate.instant(`report.${reportType}`));
    this.showInfo.emit(true);
  }

  closeDialogReport() {
    this.showReport = false;
    this.showReportUserRoles = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/report-user-roles/report-user-roles.component.ts